import { GenericField, ImgElement } from '@axinom/mosaic-ui';
import React from 'react';
import classes from './LabeledIconField.module.scss';

export interface LabeledIconFieldProps {
  name: string;
  icon: string;
  label: string;
  value: string;
}

export const LabeledIconField: React.FC<LabeledIconFieldProps> = ({
  name,
  icon,
  label,
  value,
}) => {
  return (
    <GenericField name={name} label={label}>
      <div className={classes.labeled_icon_container}>
        <ImgElement
          className={classes.square20px}
          src={icon}
          decorative={true}
        />
        <div className={classes.label}>{value}</div>
      </div>
    </GenericField>
  );
};
